// "(hover: none)" — true на устройствах с первичным touch-вводом
// (телефоны, планшеты). Используем для отключения autoFocus в тех местах,
// где модалка чаще открывается для просмотра, а не для редактирования:
// автофокус выдвигает экранную клавиатуру и перекрывает контент.
export function isTouchLike(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia?.("(hover: none)").matches ?? false;
}
